import { entities } from 'my-core/my-utils';

import betterGradesImg from 'images/artwork/blurb_better-grades.svg';
import educatorsImg from 'images/artwork/blurb_educators.svg';
import learningAlt1Img from 'images/artwork/blurb_learning-alt1.svg';
import learningImg from 'images/artwork/blurb_learning.svg';
import saveTimeImg from 'images/artwork/blurb_save-time.svg';
import tailoredImg from 'images/artwork/blurb_tailored.svg';
import universityAltImg from 'images/artwork/blurb_university-alt.svg';
import biancaImg from 'images/testimonials/bianca.jpg';
import bilalImg from 'images/testimonials/bilal.jpg';
import eishaImg from 'images/testimonials/eisha.jpg';
import emilyImg from 'images/testimonials/emily.jpg';
import emmaP from 'images/testimonials/emma-p.jpg';
import ethelImg from 'images/testimonials/ethel.jpg';
import gurveerK from 'images/testimonials/gurveer-k.jpg';
import mariaImg from 'images/testimonials/maria.jpg';
import ryconImg from 'images/testimonials/rycon.jpg';

export function getLandingIntroVideo(isCanadian) {
  return {
    videoId: `homepage-intro-${isCanadian ? 'ca' : 'us'}`,
    urls:
      isCanadian ?
        {
          hls: 'https://d3rw207pwvlq3a.cloudfront.net/shared/homepage-intro/v2_CA/hlsPlaylist.m3u8',
          original: 'https://d3rw207pwvlq3a.cloudfront.net/shared/homepage-intro/v2_CA/original/wize-intro-CA.mp4',
        }
      : {
          hls: 'https://d3rw207pwvlq3a.cloudfront.net/shared/homepage-intro/v2_US/hlsPlaylist.m3u8',
          original: 'https://d3rw207pwvlq3a.cloudfront.net/shared/homepage-intro/v2_US/original/wize-intro-US.mp4',
        },
  };
}

export const quotes = {
  grade: { stat: '98%', label: 'Achieved a grade increase' },
  recommend: { stat: '91%', label: 'Would recommend Wizeprep to a friend' },
  time: { stat: '94%', label: 'Reported Wizeprep saved them time' },
};

const emma = {
  testimonial:
    'I really like working through the simplified course and having practice questions. My scores really improved on tests.',
  author: 'Emma P',
  school: 'UBC',
  imageSrc: emmaP,
};
export const BIANCA_TESTIMONIAL = {
  testimonial: 'Wizeprep explains concepts in a very concise way that is really easy to understand.',
  author: 'Bianca L',
  school: 'McMaster',
  gradeLevel: 'Undergraduate Student',
  imageSrc: biancaImg,
  videoSrc: {
    hls: 'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/bianca/hlsPlaylist.m3u8',
    original:
      'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/bianca/original/Bianca_Long_Testimonial.mp4',
  },
};
const gurveer = {
  testimonial:
    'Wizeprep further explains the material taught by professors in lectures in simple and understandable terms.',
  author: 'Gurveer K',
  school: 'U of T',
  imageSrc: gurveerK,
  gradeLevel: 'University Student',
};

export const emily = {
  testimonial:
    'Wizeprep has been my saving grace throughout my first year of university. My grades have gone up significantly. I feel so much more confident when taking my exams, and the extra practice questions truly help me understand the material instead of just memorizing it.',
  author: 'Emily',
  gradeLevel: 'Undergraduate Student',
  imageSrc: emilyImg,
  school: 'U of A',
  videoSrc: {
    hls: 'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/emily/hlsPlaylist.m3u8',
    original:
      'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/emily/original/Emily_Long_Testimonial.mp4',
  },
};

const maria = {
  testimonial:
    'I was really struggling with my class in macroeconomics. Then, in my study group, someone talked about Wizeprep and how it helped them. To my surprise, the tutor really explained my econ class in such a way that I finally understood! I am very grateful for Wizeprep.',
  author: 'Maria',
  gradeLevel: 'Undergraduate Student',
  imageSrc: mariaImg,
  videoSrc: {
    hls: 'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/maria/hlsPlaylist.m3u8',
    original:
      'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/maria/original/Maria_Long_Testimonial.mp4',
  },
};

export const ethel = {
  testimonial:
    'Not only does Wizeprep provide clear and concise lessons for almost all of my courses, but I have access to these lessons 24/7 and can always revisit them when needed!',
  author: 'Ethel',
  gradeLevel: 'High School Student',
  imageSrc: ethelImg,
  videoSrc: {
    hls: 'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/ethel/hlsPlaylist.m3u8',
    original:
      'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/ethel/original/Ethel_Long_Testimonial.mp4',
  },
};

const rycon = {
  testimonial:
    "Wizeprep's course-specific videos and practice questions helped me to get through University Calculus and I ended up getting an A-.",
  author: 'Rycon',
  gradeLevel: 'Undergraduate Student',
  school: 'U of A',
  imageSrc: ryconImg,
  videoSrc: {
    hls: 'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/rycon/hlsPlaylist.m3u8',
    original:
      'https://d3rw207pwvlq3a.cloudfront.net/shared/student-testimonials/rycon/original/Rycon_Long_Testimonial.mp4',
  },
};

const eisha = {
  testimonial:
    'It is unexpectedly identical to the content that I am learning in school. It feels like each lesson is custom-made for me.',
  author: 'Eisha',
  gradeLevel: 'High School Student',
  imageSrc: eishaImg,
};

const sarab = {
  testimonial:
    'The Wizeprep review session taught me everything I needed to know. The instructor summarized everything clearly and showed us how to tackle many different exam questions.',
  author: 'Sarab',
  gradeLevel: 'University Student',
  school: 'Western',
};
const natalie = {
  testimonial:
    'My Wizeprep prof showed me everything we had to know for the exam. I really like that she dug through many past exams to find common questions that are likely to show up on my exam. She provided tons of tips and the course was completely worth it.',
  author: 'Natalie',
  gradeLevel: 'University Student',
  school: 'UBC',
};
const sarah = {
  testimonial:
    'My Wizeprep prof made the math seem very easy! She was thorough and simplified everything. Wizeprep is the reason why I passed my exam!',
  author: 'Sarah',
  gradeLevel: 'University Student',
  school: 'Western',
};
const harris = {
  testimonial:
    'My Wizeprep prof used easy to understand analogies that were extremely helpful. I loved having all of those tips in the PDF booklet',
  author: 'Harris',
  gradeLevel: 'University Student',
  school: 'UBC',
};
const nathalia = {
  testimonial:
    'The Wizeprep live prep session was very helpful and my instructor actually EXPLAINED every key concept and followed them with exam-like questions.',
  author: 'Nathalia',
  gradeLevel: 'University Student',
  school: 'Western',
};
const bilal = {
  testimonial: 'Wizeprep helped me save time and stress by preparing me for the exam and I highly recommend it.',
  author: 'Bilal',
  gradeLevel: 'University Student',
  school: 'Western',
  imageSrc: bilalImg,
};

const iffa = {
  testimonial:
    'Wizeprep has been extremely helpful for me when studying for the MCAT. They are here to support you from the time you sign up all the way to the end!',
  author: 'Iffah',
};

const rawlie = {
  testimonial: 'Wizeprep gave me a platform to harness my efforts without me having to sculpt it from scratch.',
  author: 'Rawlie',
};

export const KIRA = {
  testimonial:
    'I had a very seamless experience writing my MCAT with Wizeprep and I know this process would have been much more stressful if I had done it on my own.',
  author: 'Kira',
  videoSrc: {
    hls: 'https://d3rw207pwvlq3a.cloudfront.net/shared/mcat/video-testimonials/kira/hlsPlaylist.m3u8',
    original:
      'https://d3rw207pwvlq3a.cloudfront.net/shared/mcat/video-testimonials/kira/original/mcat-testimonial-kira.mov',
  },
};

const mahaM = {
  testimonial:
    'Absolutely outstanding tutor! Despite his age, he is very experienced, which shines through in his advice and strategies. I appreciate his passion for teaching because it makes sessions so exciting. Not only is my tutor gifted in explaining complex and confusing concepts in a fun, tangible way, he is great at fostering successful thought patterns, ensuring you have the right mindset for test day and beyond. He challenged me to grow as a thinker and helped me elevate my capabilities. With his help, I improved my MCAT score by 13 points and have been accepted into two medical schools so far. Ahmed demonstrated to me the power of having a great coach by your side. He absolutely is worth it!!!',
  author: 'Maha M',
};

const oliviaB = {
  testimonial:
    'My tutor was dedicated, patient, and knowledgeable. He analyzed my strengths and weaknesses and adapted my study plan to target my weaknesses. His explanations were always clear and insightful, and if I struggled to grasp a concept, he easily found another way to explain it. When I felt burnt out, he did a great job providing the motivation I needed to stay on track. It is obvious that he was passionate about helping his students improve their scores; he made resources for us to use such as question tracker sheets and a list of helpful MCAT acronyms which I found very helpful.',
  author: 'Olivia B',
};

const katieT = {
  testimonial:
    "My tutor was incredible! His ability to figure out the areas I was weakest in and give me tangible goals for each week was so great. His ability to describe, draw, and communicate complex topics in simple ways over zoom was incredible, and really helped me improve on topics I did not understand. Even when I didn't have confidence in myself my tutor always was encouraging and inspired me to continue working hard and it paid off.",
  author: 'Katie T',
};

const wizeprepTutoringStudent1 = {
  testimonial:
    "Ahmed was an amazing tutor. He not only improved my critical thinking and content knowledge but also made me realize the importance of having the right testing mindset. I'm so grateful for his help!",
  author: 'Wizeprep Tutoring Student',
};

const wizeprepTutoringStudent2 = {
  testimonial:
    "Ahmed was the best MCAT tutor I've had. He helped me improve my score 10 points on my 3rd attempt. Wish I would have found him sooner!!",
  author: 'Wizeprep Tutoring Student',
};

export const testimonials = [emma, BIANCA_TESTIMONIAL, gurveer];
export const testimonialsHomepage = [emily, BIANCA_TESTIMONIAL, maria, ethel, rycon];
export const testimonialsHomepageBlurbs = [emily, maria, bilal];
export const testimonialsStudyPass = [BIANCA_TESTIMONIAL, eisha, rycon, ethel, emily, gurveer];
export const testimonialsLivePrep = [sarab, natalie, sarah, harris, nathalia];
export const medSchoolAdmissionsTestimonials = [iffa, rawlie, BIANCA_TESTIMONIAL, KIRA];
export const testimonialsPreMedTutoring = [mahaM, oliviaB, katieT, wizeprepTutoringStudent1, wizeprepTutoringStudent2];
export const testimonialsMCAT = [
  iffa,
  {
    testimonial:
      "I started with a diagnostic of 486! I only dreamt of breaking 500 and I truly believe it was Wizeprep that brought me up to where I am now. I'm so happy I came across this course.",
    author: 'Vanessa',
  },
  {
    testimonial:
      'I have learned so much more in an hour of watching these MCAT videos than I have in a couple of days of reading my book!',
    author: 'Miriam',
  },
  {
    testimonial:
      'I found that this course was really helpful. I really appreciate how the instructor took the time to create detailed answers to the passage questions.',
    author: 'Sonya',
  },
  {
    testimonial:
      'The questions were excellent and so were the explanations. I think the layout and execution of the course was great and very thorough.',
    author: 'Haleh',
  },
  {
    testimonial:
      "Very well done and would definitely recommend! The Wizeprep Profs answer quickly and thoroughly, it's been very helpful! I feel a lot more confident!",
    author: 'Jenna',
  },
  {
    testimonial:
      "If I did not do Wizeprep's prep course, I would not be able to track my progress in the same way and understand how I can make those improvements overall.",
    author: 'Parker',
  },
  {
    testimonial:
      'I think that structure played a big role in the really good improvement that I saw in my score over the course of the program. My marks gradually improved with almost every single exam I was taking.',
    author: 'Katya',
  },
  rawlie,
  {
    testimonial:
      'All the homework is very tuned into what was actually taught in the lecture and just trying to in ingrain in your brain the principles that were taught in lecture.',
    author: 'Gabriel',
  },
  {
    testimonial:
      "Wizeprep is truly the greatest platform in terms of variety of study material and courses you might need. It covers many year one courses all the way to the MCAT and your entry into med school if thats the route you're planning to take! The staff is very helpful and try their best to be there to respond to any inquiry! It also genuinely helps to cut down on study time since you can access course notes taking away the need to sit and syphon through lectures trying to find the important points that need to be focused on! An excellent service, if you're a college student I highly recommend you give it a try there's more than likely something you need.",
    author: 'Nourlynn Kortbaoui',
    google: true,
  },
  {
    testimonial:
      "Had an amazing experience with the MCAT prep course! I loved the step-by-step approach to the complex concepts of the MCAT exam. It felt very personal through the live courses and the ability to easily contact the instructors. Although I didn't take the MCAT this year following the course, I am retaking the course this summer (for free!) and am looking forward to it. Overall, great experience with the teaching and easy-to-follow format and the 515 guarantee is a massive bonus!",
    author: 'Julia Field',
    google: true,
  },
  {
    testimonial:
      "Taking the Wizeprep MCAT 515 course was one of the best decisions I made during my MCAT journey! When I started, I was feeling overwhelmed and unsure about how to tackle such a massive exam. But Wizeprep completely changed that for me. My MCAT score improved significantly — I went from feeling underprepared to hitting my target score with confidence.The weekly review sessions were a game-changer. They kept me on track, broke down tough topics into manageable pieces, and gave me a clear understanding of what to focus on. I always left those sessions feeling more confident and ready to take on the next week. The tutors were fantastic — patient, knowledgeable, and genuinely invested in helping students succeed.What truly set Wizeprep apart was the personalized report card I received before my MCAT. It gave me detailed insights into my strengths and weaknesses, allowing me to make targeted improvements in the final stretch of my prep. With their feedback, I was able to tweak my strategy and feel fully prepared when I walked into the exam.Additionally, the med school coaching they provided was so helpful in giving me a clear picture of the bigger application process. While I'm not in med school yet, their guidance gave me a head start on thinking about the next steps in my journey.If you're looking for a program that combines excellent resources, personalized support, and a clear path to success, Wizeprep is the way to go. I'm so grateful for everything they provided during my MCAT prep and highly recommend them to anyone aiming to achieve a top score!",
    author: 'Harshal Dayani',
    google: true,
  },
  {
    testimonial:
      'Wizeprep is hands down the best educational tool for MCAT prep! The comprehensive content, easy-to-understand explanations, and practice questions are exactly what I needed to feel prepared and confident. The platform offers clear, structured lessons that cover all MCAT sections, making studying manageable and effective. The support from the Wizeprep team is amazing too—they genuinely care about helping you succeed. Highly recommend for anyone aiming for a high score!',
    author: 'S J',
    google: true,
  },
];

export const testimonialsDAT = [
  {
    testimonial: "I couldn't have done it without Jes!",
    author: 'Adrienne',
  },
  {
    testimonial:
      "Jes did an awesome job teaching the class, I'm really impressed, she kept me laughing when I should've been falling asleep so thanks! Jes went beyond exceptions!",
    author: 'Anastasia',
  },
  {
    testimonial: 'Jes was always very organized and thorough, which greatly improved the lesson experience.',
    author: 'Bram',
  },
  {
    testimonial: "I really love Jes's lectures :)",
    author: 'Cathy',
  },
  {
    testimonial: 'Jes is amazing - best teacher I ever had!',
    author: 'Chris',
  },
  {
    testimonial:
      'The way Jes organized the information into charts and diagrams really helped to clear things up and remember them.',
    author: 'Corinne',
  },
  {
    testimonial:
      "Part of the reason I'm enjoying LSAT prep so much is Jes. She is an amazing teacher. Clearly gifted. She speak with such clarity and ease. It's inspiring.",
    author: 'Elias',
  },
  {
    testimonial:
      "Jes is an absolutely fantastic teacher, and I would not have had the same DAT experience without her. When I signed up for the course, I was anticipating it to be extremely boring, but a necessary evil to do well on the test. I can't tell you how shocked I was to find myself ENJOYING an DAT class. Jes's energy and passion for teaching made the 10.5 hours of class time a week something I looked forward to. I also remember when Jes emailed us the \"welcome\" email before we met her, I saw Jes's credentials, and was worried she would be TOO smart. Most people as accomplished as Jes can't bring difficult things down to a basic level. Jes obviously proved me wrong there, too. She could explain any problem from any section to make it make complete sense, and that is a true skill. Jes went above an beyond for all of us in the class, and I am far from being the only one that thinks that.",
    author: 'Grace',
  },
  {
    testimonial:
      "There were so many tips and tricks that I learned over the past month that ultimately brought my score to where I wanted it to be during practice and also helped for the real DAT. Jes taught very well, and made the material interesting, and I think that helped it stick. I also never thought I'd see the day when I was better at chem than bio. Thanks a million to Jes for helping me remain calm and improve my score in that category. (I went from a 15 during my first practice test to a 28 on my last practice set yesterday).",
    author: 'Harleen',
  },
  {
    testimonial: 'Jes really made DAT-studying more interesting than i would have ever expected.',
    author: 'Kelvin',
  },
  {
    testimonial:
      "Scores have officially been released and thanks to all Jes's help I am more then happy with my scores!!",
    author: 'Laura',
  },
  {
    testimonial:
      "The consistency and forthrightness in motivating us to study was very helpful; I particularly appreciated Jes's daily emails and pop quizzes.",
    author: 'Marcus',
  },
  {
    testimonial:
      "As a student in class, I really appreciated Jes's energy, positivity and professionalism. I've done 6 years of university course work and met some really good professors along the way, but Jes truly stood out as an instructor! Jes's classes gave me a boost in preparation and a hope that certain difficult biology mechanisms that I was fearful about were not that 'scary' after all :))) And, of course, Jes's amusing stories were great and added an 'emotional' dimension to the material we were learning.",
    author: 'Marisa',
  },
  {
    testimonial:
      'I just wrote the DAT this Saturday and thought it went very well. The strategies that Jes had taught me were very beneficial - especially for PAT. I would like to thank Jes for the help.',
    author: 'Natasha',
  },
  {
    testimonial: 'I really appreciate everything Jes did for me. Jes was an awesome teacher.',
    author: 'Pascal',
  },
  {
    testimonial: "I'm entirely certain this test would have gone terribly without Jes's help!",
    author: 'Ravi',
  },
  {
    testimonial: 'I miss the DAT classes so much that I wish I could take them again!',
    author: 'Sarah',
  },
  {
    testimonial:
      "I admire Jes's passion and commitment to her students in helping them success both through the emails she send out and her teaching.",
    author: 'Uzair',
  },
];

export const testimonialsLSAT = [
  {
    testimonial:
      'What I enjoyed most about the course was the supportive learning environment and the way complex LSAT strategies were broken down into easy-to-understand steps. The instructor was approachable and always open to questions, which made it comfortable to participate and stay engaged. I also appreciated how the course allowed me to learn at my own pace while still keeping me accountable through regular check-ins and practice tests.',
    author: 'Angela',
  },
  {
    testimonial:
      "The classes and explanations was incredibly helpful! The instructor's teaching skills are amazing and he's very supportive.",
    author: 'Amara',
  },
  {
    testimonial: 'The instructor was very encouraging and smart. Also, the student discussions were awesome.',
    author: 'Celine',
  },
  {
    testimonial:
      'I enjoyed the materials provided and the instructor, I feel like the combination of both was great for me and really helped me throughout learning about the LSAT and providing crucial information and tips and tricks.',
    author: 'Natalie',
  },
  {
    testimonial: 'Wizeprep was great, the teacher is able to explain things simply without overwhelming you.',
    author: 'Jessica',
  },
  {
    testimonial: 'The instructor was very interactive and knowledgable, and the lesson journals were very informative.',
    author: 'Lauren',
  },
];

const PRODUCT_TESTIMONIALS = [
  {
    testimonial:
      'Aaron was extremely well prepared for each lesson and provided me with lots of strategies and help to improve my scores. The material was up-to-date and the coursework was plenty to keep me learning more and more.',
    author: 'Alex M',
    product: ['sat', 'act'],
  },
  {
    testimonial:
      'The sessions were all very informative, and brought forth concepts I never thought about. As I took the various practice tests I could feel myself being more comfortable with the timing and the questions. I believe if it did not take the tests or the tutoring course i would not have been prepared for the SAT. Going over questions with a tutor was definitely more beneficial than doing them on my own.',
    author: 'Brad M',
    product: ['sat'],
  },
  {
    testimonial:
      "Successful both in the classroom and on the volleyball court, our daughter has dreamed of playing NCAA volleyball in the Ivy League since the start of high school.  We hired Aaron to give her the best shot at achieving the requisite mark on the ACT exam to be considered for the Ivy's.  Within only 7 weeks, Aaron helped our daughter achieve her ACT goal and, combined with her academics, gain entry into Columbia University in New York.  In those 7 weeks, our daughter's composite score improved by 4 points overall and an impressive, 11 points in one of the subject areas.  Through the process, Aaron adjusted his teaching methods to ensure a connection with our daughter and helped her approach problems from a variety of different angles.  Our family is very grateful to Aaron for all of his assistance.",
    author: 'Mary T',
    product: ['act', 'act-tutoring'],
  },
  {
    testimonial:
      'I liked how the instructor took the time to explain all the questions that I asked and how there were many many resources available for me to use both online and offline. The feedback that I got helped me when I was practicing on my own and guided me very well in focusing on specifics.',
    author: 'Faith W',
    product: ['sat', 'act'],
  },
  {
    testimonial: 'I had a great experience! Aaron was a great teacher. I learned a lot and feel ready for my exam!',
    author: 'Sophie L',
    product: ['sat', 'sat-tutoring', 'act-tutoring', 'act'],
  },
  {
    testimonial:
      "The tutoring was enjoyable and wasn't boring.  The tutor was also always in good spirits when I came in.",
    author: 'Josh M',
    product: ['sat-tutoring', 'act-tutoring'],
  },
  {
    testimonial:
      'Very kind tutor. I loved that I could ask questions about other university things like sat subject tests. Tutoring also boosted my scores a lot!',
    author: 'Christine R',
    product: ['sat-tutoring'],
  },
  {
    testimonial:
      'Aaron is a great teacher and very friendly. I really, really learned from him. He was very knowledgeable and made learning fun! He is very friendly and made me feel comfortable.',
    author: 'Sarah M',
    product: ['sat', 'act'],
  },
  {
    testimonial:
      "I'm happy to report I scored full 36s across all sections for the June 2023 ACT! Thank you so much for all your help.",
    author: 'Luke K',
    product: ['act'],
  },
  {
    testimonial:
      'I liked how different concepts for all sections of the SAT were involved in the lessons. Whenever I had any difficulties or questions, Aaron incorporated similar concepts into the lesson, which really helped me to increase my understanding.',
    author: 'Nadia S',
    product: ['sat'],
  },
  {
    testimonial:
      'I really appreciated all of the extra assistance regarding practice tests as well as the ability to email questions and receive fast responses. I was also impressed by the amount of work that I was given to complete, a sure sign of an efficient testing agency.',
    author: 'Anya B',
    product: ['sat', 'act', 'sat-tutoring', 'act-tutoring'],
  },
  {
    testimonial:
      "Aaron was literally the greatest tutor i've had in my life and without his help I would not have felt as confident as I did going into the test. (hopefully that confidence paid off)",
    author: 'Adam S',
    product: ['sat-tutoring', 'act-tutoring'],
  },
  {
    testimonial:
      "Aaron was very knowledgeable, great at explaining the concepts I didn't grasp, and taught me lots of time-saving techniques.",
    author: 'Melanie R',
    product: ['sat', 'act-tutoring', 'sat-tutoring', 'act'],
  },
  {
    testimonial: 'Aaron is awesome. Helped me improve so much and was a great help and great guy to  Work with',
    author: 'Kevin O',
    product: ['sat', 'act-tutoring', 'sat-tutoring', 'act'],
  },
  {
    testimonial: 'Aaron is super cool and I learned things',
    author: 'Sophia V',
    product: ['sat', 'act-tutoring', 'sat-tutoring', 'act'],
  },
  {
    testimonial:
      'Aaron was an absolutely incredible tutor, especially due to his comprehensive lessons, ability to adapt to my strengths/weaknesses, and establishment of a manageable yet efficient pace. I would recommend him to any student planning to take the SAT.',
    author: 'Aly S',
    product: ['sat-tutoring'],
  },
];

export const getSATTestimonials = () => PRODUCT_TESTIMONIALS.filter(t => t.product.includes('sat'));
export const getACTTestimonials = () => PRODUCT_TESTIMONIALS.filter(t => t.product.includes('act'));
export const getSATTutoringTestimonials = () => PRODUCT_TESTIMONIALS.filter(t => t.product.includes('sat-tutoring'));
export const getACTTutoringTestimonials = () => PRODUCT_TESTIMONIALS.filter(t => t.product.includes('act-tutoring'));

export const blurbs = {
  educators: {
    header: 'Expert Instructors',
    subheader: 'Our instructors have years of experience as TAs and tutors helping students get better grades.',
    source: educatorsImg,
  },
  time: {
    header: 'Time Saving',
    subheader: 'We take the guess work out of studying. 94% of students say Wizeprep saves them time when studying.',
    source: saveTimeImg,
  },
  course: {
    header: 'Customized Content',
    subheader: "We customize our lessons to your course to make what you're learning in class easy to understand.",
    source: tailoredImg,
  },
  learn: {
    header: 'Made for Learning',
    subheader: "We don't just give out answers, we guide students of all levels to foundational understanding.",
    source: learningImg,
  },
  better_grades: {
    header: 'Get Better Grades',
    subheader: `98% of students who study with Wizeprep reported higher${entities.noBreakSpace}grades`,
    source: betterGradesImg,
  },
  understand: {
    header: 'Really Understand Concepts',
    subheader: `Our instructors know how to make complex topics feel${entities.noBreakSpace}simple`,
    source: learningAlt1Img,
  },
  optimize: {
    header: `Cut Your Study Time in${entities.noBreakSpace}Half`,
    subheader: `Quick, curated lessons allow you to focus your study time where it${entities.noBreakSpace}matters`,
    source: universityAltImg,
  },
};

export const wavePath =
  'M0,224L48,202.7C96,181,192,139,288,144C384,149,480,203,576,224C672,245,768,235,864,202.7C960,171,1056,117,1152,90.7C1248,64,1344,64,1392,64L1440,64L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z';

export const getBetterGradesStudents = [maria, rycon, emily];
